import { render, staticRenderFns } from "./OrderByArrowToggle.vue?vue&type=template&id=7c07d6ac&"
import script from "./OrderByArrowToggle.vue?vue&type=script&lang=js&"
export * from "./OrderByArrowToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports